import React from "react"
import Image from "next/image"
import Link from "next/link"

import tiktok from "/public/icons/socials/tiktok.png"
import facebook from "/public/icons/socials/facebook.png"
import instagram from "/public/icons/socials/instagram.png"
import linkedin from "/public/icons/socials/linkedin.png"
import twitter from "/public/icons/socials/twitter.png"
import pinterest from "/public/icons/socials/pinterest.png"
import youtube from "/public/icons/socials/youtube.png"

type props = {}

export const Footer: React.FC<props> = (props) => {
  return (
    <section>
      <div className='wrapper footer'>

        <div className='credits'>
          <p className='caption gray-text'>
            Ruby is the smart money-saving app that helps you Find deals at your favorite
            online stores & Save money with Coupons, Promo codes, Cash back and Ruby
            points.
            We earn commissions from affiliate networks when you activate cashback through our extension and shop with participating retailers. 
            These commissions are shared with you as cashback!
          </p>
          <p className='footnote gray-text'>
            <Image src='/ruby-logo.png' alt='Ruby Logo' width={14} height={14 } />
            Copyright Ruby 2025, All rights reserved.
          </p>
        </div>
      </div>
    </section>
  )
}
